import axios from 'axios'
import rateLimit from 'axios-rate-limit'
import setup from '@/../../cortex/setup.js'

axios.interceptors.response.use(
  (res => {
    console.log(res.data.json);
    // Important: response interceptors **must** return the response.
    return res;
  }),
  (error => {
    console.log('Interceptor caught error: ', error)
    const status = error.response ? error.response.status : null
    if (status != 401) {
      return Promise.reject(error)
    }
    const origRequest = error.config
    if (origRequest.url === 'https://auth.entrinsia.net/auth/refresh') {
      window.location = 'https://cortex.entrinsia.net'
      return Promise.reject(error)
    }
    if (!origRequest._retry) {
      origRequest._retry = true
      console.log('token failure, access denied, trying to refresh')
      const refreshToken = localStorage.getItem('refreshToken')
      return loginServer
        .post('/auth/refresh', {'refresh-token': refreshToken})
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            console.log('tokens refreshed')
            let data = response.data
            localStorage.setItem('token', data['x-access-token'])
            localStorage.setItem('refreshToken', data['refresh-token'])
            axios.defaults.headers['x-access-token'] = localStorage['token']
          }
        })
    }
    return Promise.reject(error)
  }
))

var authServer = axios.create({
  baseURL: 'https://auth.entrinsia.net',
  timeout: 10000
})

var loginServer = axios.create({
  baseURL: 'https://auth.entrinsia.net',
  timeout: 10000
})

var computeServer = axios.create({
  baseURL: 'https://devcompute.entrinsia.net'
})

var reportServer = axios.create({ 
  baseURL: "https://reports.entrinsia.net"
})

var fileServer = axios.create({ 
  baseURL: "https://files.entrinsia.net"
})

var localServer = axios.create({ 
  baseURL: "http://localhost:8080"
})
var origApiServer = axios.create({})

var apiServer = rateLimit(
  axios.create({
    timeout: 10000
  }),
  { 
    maxRequests: 8,
    perMilliseconds: 500,
  }
)

localServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.origToken,
    'Content-Type': 'Application/json',
  }
  return config
})


loginServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.origToken,
    'Content-Type': 'Application/json',
  }
  return config
})

authServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.origToken,
    'Content-Type': 'Application/json'
  }
  return config
})

computeServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.token,
    'Content-Type': 'Application/json'
  }
  return config
})

reportServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.token,
    'Content-Type': 'Application/json'
  }
  return config
})

// apiServer.interceptors.request.use(config => {
//   config.headers = {
//     'x-access-token': localStorage.token
//   }
//   return config
// })

apiServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.token,
    'Content-Type': 'Application/json'
  }
  return config
})

origApiServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.origToken,
    'Content-Type': 'Application/json'
  }
  return config
})

fileServer.interceptors.request.use(config => {
  config.headers = {
    'x-access-token': localStorage.token,
    'Content-Type': 'Application/json'
  }
  return config
})

apiServer.interceptors.response.use(
  (res => {
    // console.log(res.data)
    return res
  }),
  error => {
    const status = error.response ? error.response.status : null
    if (status == null) {
      return Promise.reject(new Error('Server unreachable'))
    }
    if (status != 401) {
      return Promise.reject(error)
    }
    const origRequest = error.config
    if (origRequest.url === 'https://auth.entrinsia.net/auth/refresh') {
      window.location = 'https://cortex.entrinsia.net'
      return Promise.reject(error)
    }
    if (!origRequest._retry) {
      origRequest._retry = true
      console.log('token failure, access denied, trying to refresh')
      const refreshToken = localStorage.getItem('refreshToken')
      return loginServer
        .post('/auth/refresh', {'refresh-token': refreshToken})
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            let data = response.data
            localStorage.setItem('token', data['x-access-token'])
            localStorage.setItem('refreshToken', data['refresh-token'])
            axios.defaults.headers['x-access-token'] = localStorage['token']
          }
        })
    }
    return Promise.reject(error)
  }
)

computeServer.interceptors.response.use(
  response => response,
  error => {
    console.log('apiServer response error: ', JSON.stringify(error))
    const status = error.response ? error.response.status : null
    if (status == null) {
      return Promise.reject(new Error('Server unreachable'))
    }
    if (status != 401) {
      return Promise.reject(error)
    }
    const origRequest = error.config
    if (origRequest.url === 'https://auth.entrinsia.net/auth/refresh') {
      window.location = 'https://cortex.entrinsia.net'
      return Promise.reject(error)
    }
    if (!origRequest._retry) {
      origRequest._retry = true
      console.log('token failure, access denied, trying to refresh')
      const refreshToken = localStorage.getItem('refreshToken')
      return loginServer
        .post('/auth/refresh', {'refresh-token': refreshToken})
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            let data = response.data
            localStorage.setItem('token', data['x-access-token'])
            localStorage.setItem('refreshToken', data['refresh-token'])
            axios.defaults.headers['x-access-token'] = localStorage['token']
          }
        })
    }
    return Promise.reject(error)
  }
)

reportServer.interceptors.response.use(
  response => response,
  error => {
    const status = error.response ? error.response.status : null
    if (status != 401) {
      return Promise.reject(error)
    }
    const origRequest = error.config
    if (origRequest.url === 'https://auth.entrinsia.net/auth/refresh') {
      window.location = 'https://cortex.entrinsia.net'
      return Promise.reject(error)
    }
    if (!origRequest._retry) {
      origRequest._retry = true
      console.log('token failure, access denied, trying to refresh')
      const refreshToken = localStorage.getItem('refreshToken')
      return loginServer
        .post('/auth/refresh', {'refresh-token': refreshToken})
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            let data = response.data
            localStorage.setItem('token', data['x-access-token'])
            localStorage.setItem('refreshToken', data['refresh-token'])
            axios.defaults.headers['x-access-token'] = localStorage['token']
          }
        })
    }
    return Promise.reject(error)
  }
)

loginServer.interceptors.response.use(
  (res => {
    // Important: response interceptors **must** return the response.
    return res;
  }),
  (error => {
    const status = error.response ? error.response.status : null
    if (status == null) {
      return Promise.reject(error)
    }
    if (status != 401) {
      return Promise.reject(error)
    }
    const origRequest = error.config
    if (origRequest.url === 'https://auth.entrinsia.net/auth/refresh') {
      window.location = 'https://cortex.entrinsia.net'
      return Promise.reject(error)
    }
    if (!origRequest._retry) {
      origRequest._retry = true
      console.log('token failure, access denied, trying to refresh')
      const refreshToken = localStorage.getItem('refreshToken')
      return loginServer
        .post('/auth/refresh', {'refresh-token': refreshToken})
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            let data = response.data
            localStorage.setItem('token', data['x-access-token'])
            localStorage.setItem('refreshToken', data['refresh-token'])
            axios.defaults.headers['x-access-token'] = localStorage['token']
          } else {
						// return Promise.reject(error)
					}
        })
    }
    return Promise.reject(error)
  })
)

computeServer.interceptors.response.use(
  response => response,
  error => {
    const status = error.response ? error.response.status : null
    if (status != 401) {
      return Promise.reject(error)
    }
    const origRequest = error.config
    if (origRequest.url === 'https://auth.entrinsia.net/auth/refresh') {
      window.location = 'https://cortex.entrinsia.net'
      return Promise.reject(error)
    }
    if (!origRequest._retry) {
      origRequest._retry = true
      console.log('token failure, access denied, trying to refresh')
      const refreshToken = localStorage.getItem('refreshToken')
      return axios
        .post('/auth/refresh', {'refresh-token': refreshToken})
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            let data = response.data
            localStorage.setItem('token', data['x-access-token'])
            localStorage.setItem('refreshToken', data['refresh-token'])
            axios.defaults.headers['x-access-token'] = localStorage['token']
          }
        })
    }
    return Promise.reject(error)
  }
)

var axiosInstances = {
  authServer,
  loginServer,
  origApiServer,
  apiServer,
  computeServer,
  reportServer,
  fileServer,
  localServer
}

export default axiosInstances
